import {
  FaChevronDown,
  FaChevronUp,
  FaSort,
  FaSortDown,
  FaSortUp,
} from "react-icons/fa";
import {
  Checkbox,
  CircularProgress,
  Collapse,
  InputAdornment,
  Popper,
  TextField,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import ModalFilterDistributor from "./defectaComponents/ModalFilterDistributor";
import PopupRangeCalendar from "../../common/particles.jsx/PopupRangeCalendar";
import { archiveDefecta, getDefectaList } from "../../../services/defecta";
import JumpPagePagination from "../../common/particles.jsx/JumpPagePagination";
import useDebounce from "../../hooks/useDebounce";
import ModalCreateDefecta from "./defectaComponents/ModalCreateDefecta";
import LoadingBackdrop from "../../common/particles.jsx/LoadingBackdrop";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const INITIAL_REQ = {
  search: "",
  due_date_start: "",
  due_date_end: "",
  distributor_id: [],
  sort_price: 0, //0.default, 1.ascending, 2.descending
  sort_stock: 0, //0.default, 1.ascending, 2.descending
  limit: 50,
  offset: 1,
  is_sort_stock: true,
};

const DefectaList = ({ isWarehouse, isArchive }) => {
  const navigate = useNavigate();

  const [reqBody, setReqBody] = useState({
    ...INITIAL_REQ,
    warehouse: isWarehouse ? isWarehouse : false,
    is_archive: isArchive ? isArchive : false,
  });
  const [openDistributor, setOpenDistributor] = useState(false);
  const [anchorElCal, setAnchorElCal] = useState(null);
  const [productArr, setProductArr] = useState([]);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [anchorElForecast, setAnchorElForecast] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [collapseArr, setCollapseArr] = useState([]);

  const debounce = useDebounce(reqBody.search, 500);

  const handleCheckProduct = (item, checked) => {
    var tempArr = [...productArr];

    item.distributor.map((batch) => {
      var foundIndex = tempArr.findIndex(
        (product) => product.batch_id === batch.batch_id
      );

      if (checked && foundIndex < 0) {
        tempArr = [...tempArr, { ...batch, product_id: item.product_id }];
      }
      if (!checked && foundIndex >= 0)
        tempArr = [
          ...tempArr.slice(0, foundIndex),
          ...tempArr.slice(foundIndex + 1),
        ];
    });

    setProductArr(tempArr);
  };

  const handleCheckBatch = (batch, item) => {
    const foundIndex = productArr.findIndex(
      (product) => product.batch_id === batch.batch_id
    );

    setProductArr(
      foundIndex < 0
        ? [...productArr, { ...batch, product_id: item.product_id }]
        : [
            ...productArr.slice(0, foundIndex),
            ...productArr.slice(foundIndex + 1),
          ]
    );
  };

  const handleArchive = () => {
    const productIdArr = [];

    productArr.map((item) => {
      var isExist = productIdArr.find((id) => id === item.product_id);
      if (!isExist) productIdArr.push(item.product_id);
    });

    mutateArchive({
      product_id: productIdArr,
      is_archive: isArchive ? !isArchive : true,
      warehouse: isWarehouse ? isWarehouse : false,
    });
  };

  const refetchList = () => {
    setProductArr([]);
    setReqBody({
      ...INITIAL_REQ,
      warehouse: isWarehouse ? isWarehouse : false,
      is_archive: isArchive ? isArchive : false,
    });
    mutateList({
      ...INITIAL_REQ,
      warehouse: isWarehouse ? isWarehouse : false,
      is_archive: isArchive ? isArchive : false,
    });
  };

  const {
    mutate: mutateList,
    data: dataList,
    isLoading: isLoadingList,
  } = useMutation({
    mutationFn: getDefectaList,
  });

  const { mutate: mutateArchive, isLoading: isLoadingArchive } = useMutation({
    mutationFn: archiveDefecta,
    onSuccess: () => {
      refetchList();
    },
  });

  useEffect(() => {
    setCollapseArr([]);
    mutateList(reqBody);
  }, [
    debounce,
    reqBody.due_date_start,
    reqBody.due_date_end,
    reqBody.distributor_id,
    reqBody.sort_price,
    reqBody.sort_stock,
    reqBody.limit,
    reqBody.offset,
  ]);

  return (
    <div>
      <LoadingBackdrop isLoading={isLoadingArchive} />

      <div
        className={`bg-white rounded-lg p-2 ${isArchive ? "" : "mb-[70px]"}`}
      >
        <div className="w-full lg:flex items-center justify-between gap-2">
          <div className="w-full flex items-center gap-2 mb-2">
            <div
              className={`w-full lg:w-fit border-2 rounded-md flex items-center justify-between gap-2 md:gap-4 p-2 cursor-pointer ${
                reqBody.due_date_start === "" || reqBody.due_date_end === ""
                  ? "hover:bg-gray-100 bg-white"
                  : "bg-[#F1FAF0] text-[#6F955B] border-[#6F955B]"
              }`}
              onClick={(e) => setAnchorElCal(e.currentTarget)}
            >
              <p className="truncate">
                {reqBody.due_date_start === "" || reqBody.due_date_end === ""
                  ? "Tanggal Kedaluwarsa"
                  : reqBody.due_date_start + " s/d " + reqBody.due_date_end}
              </p>
              <FaChevronDown />
            </div>
            <div
              className={`w-full lg:w-fit border-2 rounded-md flex items-center justify-between gap-2 md:gap-4 p-2 cursor-pointer ${
                reqBody.distributor_id.length === 0
                  ? "hover:bg-gray-100 bg-white"
                  : "bg-[#F1FAF0] text-[#6F955B] border-[#6F955B]"
              }`}
              onClick={() => setOpenDistributor(true)}
            >
              <p>Distributor </p>
              <div className="flex items-center gap-2">
                <div
                  className={`${
                    reqBody.distributor_id.length === 0 ? "" : "bg-[#94C679]"
                  } text-white p-2 rounded-full flex items-center justify-center w-[18px] h-[18px] text-[10px]`}
                >
                  {reqBody.distributor_id.length === 0
                    ? ""
                    : reqBody.distributor_id.length}
                </div>
                <FaChevronDown />
              </div>
            </div>
            <button
              type="button"
              className="text-[#94C679] border-2 border-[#94C679] bg-[#F1FAF0] hover:bg-gray-300 hover:bg-gray-300 rounded-md w-fit py-2 px-4 text-[12px] whitespace-nowrap"
              onClick={() =>
                navigate(
                  `${isWarehouse ? "/central-warehouse" : ""}/defecta${
                    isArchive ? "" : "/archive"
                  }`
                )
              }
            >
              Daftar {isArchive ? "Defecta" : "Arsip"}
            </button>
            <button
              type="button"
              className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2 px-4 text-[12px] whitespace-nowrap disabled:bg-gray-300"
              disabled={productArr.length === 0}
              onClick={handleArchive}
            >
              {isArchive ? "Tampilkan" : "Arsipkan"} Produk
            </button>
          </div>
          <div className="w-full flex items-center gap-2 mb-2">
            <TextField
              value={reqBody.search}
              onChange={(e) =>
                setReqBody((prevVal) => ({
                  ...prevVal,
                  search: e.target.value,
                }))
              }
              fullWidth
              placeholder="Cari nama produk atau distributor"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
            {isArchive ? null : (
              <button
                type="button"
                className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2 px-4 text-[12px] whitespace-nowrap disabled:bg-gray-300"
                onClick={() => setOpenModalCreate(true)}
                disabled={
                  !dataList ||
                  isLoadingList ||
                  (dataList && dataList.count === 0) ||
                  productArr.length === 0
                }
              >
                Pilih Produk
              </button>
            )}
          </div>
        </div>

        <div className="flex w-full mb-4 mt-2">
          <div className="w-full">
            <div className="block overflow-x-auto w-full">
              <table className="w-full overflow-x-auto-md border-collapse">
                <thead className="bg-[#F7F8F9]">
                  <th className="p-2 text-center w-fit">
                    <Checkbox
                      checked={
                        dataList && dataList.count > 0
                          ? productArr.length ===
                            dataList.data.reduce(
                              (acc, num) => acc + num.distributor.length,
                              0
                            )
                          : false
                      }
                      onChange={(_, checked) =>
                        setProductArr(
                          checked
                            ? dataList.data
                                .map((item) =>
                                  item.distributor.map((batch) => ({
                                    ...batch,
                                    product_id: item.product_id,
                                  }))
                                )
                                .flat()
                            : []
                        )
                      }
                      disabled={!dataList || (dataList && dataList.count === 0)}
                    />
                  </th>
                  <th className="p-2 whitespace-nowrap">Nama Produk</th>
                  <th className="p-2 text-center">Satuan</th>
                  <th className="p-2 text-center whitespace-nowrap">
                    No. Batch
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Tgl. Kedaluwarsa
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    HNA Satuan
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">Diskon</th>
                  <th className="p-2 text-center whitespace-nowrap">PPN</th>
                  <th className="p-2 text-center whitespace-nowrap">DPP</th>
                  <th className="p-2 cursor-pointer hover:text-gray-400">
                    <div
                      className="flex items-center justify-between gap-4 whitespace-nowrap"
                      onClick={() =>
                        setReqBody((prevVal) => ({
                          ...prevVal,
                          is_sort_stock: false,
                          sort_price:
                            prevVal.sort_price === 2
                              ? 0
                              : prevVal.sort_price + 1,
                        }))
                      }
                    >
                      <p>Harga Akhir</p>
                      {reqBody.sort_price === 1 ? (
                        <FaSortUp />
                      ) : reqBody.sort_price === 2 ? (
                        <FaSortDown />
                      ) : (
                        <FaSort />
                      )}
                    </div>
                  </th>
                  <th className="p-2 text-center whitespace-nowrap">
                    Subtotal
                  </th>
                  <th className="p-2 text-center whitespace-nowrap cursor-pointer hover:text-gray-400">
                    <div
                      className="flex items-center justify-end gap-4 whitespace-nowrap"
                      onClick={() =>
                        setReqBody((prevVal) => ({
                          ...prevVal,
                          is_sort_stock: true,
                          sort_stock:
                            prevVal.sort_stock === 2
                              ? 0
                              : prevVal.sort_stock + 1,
                        }))
                      }
                    >
                      <p>Stok</p>
                      {reqBody.sort_stock === 1 ? (
                        <FaSortUp />
                      ) : reqBody.sort_stock === 2 ? (
                        <FaSortDown />
                      ) : (
                        <FaSort />
                      )}
                    </div>
                  </th>
                </thead>
                <tbody>
                  {dataList && !isLoadingList && dataList.data ? (
                    dataList.data.map((item, i) => {
                      return (
                        <>
                          <tr
                            className={`border-b-2 cursor-pointer hover:bg-gray-100`}
                            onClick={() => {
                              const index = collapseArr.findIndex(
                                (id) => id === item.product_id
                              );

                              setCollapseArr(
                                index < 0
                                  ? [...collapseArr, item.product_id]
                                  : [
                                      ...collapseArr.slice(i, index),
                                      ...collapseArr.slice(index + 1),
                                    ]
                              );
                            }}
                          >
                            <td className="p-2 text-center">
                              <Checkbox
                                checked={item.distributor.every((product) =>
                                  productArr
                                    .map((el) => el.batch_id)
                                    .includes(product.batch_id)
                                )}
                                onChange={(_, checked) => {
                                  handleCheckProduct(item, checked);
                                }}
                              />
                            </td>
                            <td colSpan={9} className="p-2">
                              <div>
                                <div className="flex items-center gap-2">
                                  <p className="font-semibold">
                                    {item.product_name}
                                  </p>
                                  <p className="bg-green-100 text-green-500 py-1 px-2 rounded-full mb-1">
                                    Total stok: {item.total_product}{" "}
                                    {item.distributor[0]?.satuan}
                                  </p>
                                </div>
                                {isWarehouse ? null : (
                                  <p>
                                    Total stok warehouse: {item.stock_warehouse}{" "}
                                    {item.distributor[0]?.satuan}
                                  </p>
                                )}
                              </div>
                            </td>
                            <td className="text-right p-2 whitespace-nowrap">
                              {item.forecast_plan > 0 ? (
                                <div className="w-full flex justify-end">
                                  <div
                                    className="flex items-center gap-2 text-[#071B82] cursor-pointer"
                                    onMouseEnter={(e) => {
                                      setAnchorElForecast(e.currentTarget);

                                      setSelectedProduct({
                                        forecast_plan: item.forecast_plan,
                                        satuan: item.distributor[0]?.satuan,
                                      });
                                    }}
                                    onMouseLeave={() => {
                                      setAnchorElForecast(null);
                                      setSelectedProduct(null);
                                    }}
                                  >
                                    <p>
                                      Forecast plan: {item.forecast_plan}{" "}
                                      {item.distributor[0]?.satuan}
                                    </p>
                                    <IoIosInformationCircleOutline className="text-[24px]" />
                                  </div>
                                </div>
                              ) : null}
                            </td>
                            <td className="text-center p-2">
                              {collapseArr.includes(item.product_id) ? (
                                <FaChevronUp />
                              ) : (
                                <FaChevronDown />
                              )}
                            </td>
                          </tr>

                          {collapseArr.includes(item.product_id)
                            ? item.distributor.map((batch, batchIndex) => {
                                return (
                                  <tr
                                    className={`border-b-2 cursor-pointer hover:bg-gray-100`}
                                    onClick={() =>
                                      handleCheckBatch(batch, item)
                                    }
                                    key={batchIndex}
                                  >
                                    <td className="p-2 text-center">
                                      <Checkbox
                                        checked={
                                          productArr.findIndex(
                                            (product) =>
                                              product.batch_id ===
                                              batch.batch_id
                                          ) >= 0
                                        }
                                        onChange={() => {
                                          handleCheckBatch(batch, item);
                                        }}
                                      />
                                    </td>
                                    <td className="p-2">
                                      {batch.distributor_name}
                                    </td>
                                    <td className="p-2 text-center">
                                      {batch.satuan}
                                    </td>
                                    <td className="p-2 text-center">
                                      {batch.batch_number}
                                    </td>
                                    <td className="p-2 text-center">
                                      {batch.due_date}
                                    </td>
                                    <td className="p-2 text-center">
                                      {toIDR(batch.hna)}
                                    </td>
                                    <td className="p-2 text-center">
                                      {batch.discount}%
                                    </td>
                                    <td className="p-2 text-center">
                                      {batch.ppn * 100}%
                                    </td>
                                    <td className="p-2 text-center">
                                      {toIDR(batch.dpp)}
                                    </td>
                                    <td className="p-2 text-center">
                                      {toIDR(batch.net_price)}
                                    </td>
                                    <td className="p-2 text-center">
                                      {toIDR(batch.subtotal)}
                                    </td>
                                    <td className="p-2 text-center">
                                      <p className="bg-green-100 text-green-500 py-1 px-2 rounded-full whitespace-nowrap">
                                        {`${batch.stock} ${batch.satuan}`}
                                      </p>
                                    </td>
                                  </tr>
                                );
                              })
                            : null}
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={12} className="p-2 text-center border-b-2">
                        {isLoadingList ? (
                          <CircularProgress size={20} />
                        ) : (
                          <div className="py-5">
                            <p className="text-[18px] font-semibold mb-2">
                              Tidak ada hasil
                            </p>
                            <p className="mb-4">
                              Ubah filter atau kata kunci untuk menemukan produk
                            </p>
                            <button
                              type="button"
                              className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2 px-4 text-[14px] whitespace-nowrap"
                              onClick={() =>
                                dataList && dataList.count === 0
                                  ? setReqBody({
                                      ...INITIAL_REQ,
                                      warehouse: isWarehouse
                                        ? isWarehouse
                                        : false,
                                    })
                                  : mutateList(reqBody)
                              }
                            >
                              {dataList && dataList.count === 0
                                ? "Hapus Filter"
                                : "Muat Ulang"}
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {dataList && !isLoadingList && dataList.count > 0 ? (
          <JumpPagePagination
            offset={reqBody.offset}
            limit={reqBody.limit}
            setOffset={(e) =>
              setReqBody((prevVal) => ({ ...prevVal, offset: e }))
            }
            setLimit={(e) => {
              setReqBody((prevVal) => ({ ...prevVal, limit: e }));
            }}
            total={dataList.count}
            canChangeLimit={true}
          />
        ) : null}
      </div>

      {isArchive ? null : (
        <div
          className={`bg-[#071B82] text-white fixed bottom-0 left-0 lg:left-[260px] min-h-[60px] px-[20px] py-[10px] w-full lg:w-[calc(100%-260px)] shadow-lg shadow-slate-900/20 shadow-b-2 shadow-r-[3px] -shadow-spread-2 text-[12px] flex items-center z-50`}
        >
          <div className="flex items-center justify-between w-full items-center w-full">
            <p className="text-[14px]">{productArr.length} data terpilih</p>
            <button
              type="button"
              className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2 px-4 text-[12px] whitespace-nowrap disabled:bg-gray-300"
              onClick={() => setOpenModalCreate(true)}
              disabled={
                !dataList ||
                isLoadingList ||
                (dataList && dataList.count === 0) ||
                productArr.length === 0
              }
            >
              Pilih Produk
            </button>
          </div>
        </div>
      )}

      <Popper
        placement="bottom"
        open={Boolean(anchorElForecast)}
        anchorEl={anchorElForecast}
        sx={{ maxWidth: "200px" }}
        modifiers={[
          {
            name: "arrow",
            enabled: true,
          },
        ]}
      >
        <div className="bg-[#454257] text-white text-[10px] p-2 rounded-md border text-wrap whitespace-wrap overflow-hidden break-words">
          Forecast 60 hari terakhir (Standar DO 30):{" "}
          {selectedProduct?.forecast_plan} {selectedProduct?.satuan}
        </div>
      </Popper>

      <ModalFilterDistributor
        open={openDistributor}
        setOpen={setOpenDistributor}
        reqBody={reqBody}
        setReqBody={setReqBody}
        isWarehouse={isWarehouse}
      />

      <ModalCreateDefecta
        open={openModalCreate}
        setOpen={setOpenModalCreate}
        productArr={productArr}
        setProductArr={setProductArr}
        isWarehouse={isWarehouse}
        refetchList={() => {
          refetchList();
        }}
      />

      <PopupRangeCalendar
        anchorElCal={anchorElCal}
        setAnchorElCal={setAnchorElCal}
        startDate={reqBody.due_date_start}
        endDate={reqBody.due_date_end}
        setStartDate={(e) => {
          setReqBody((prevValue) => ({
            ...prevValue,
            due_date_start: e ? e : "",
          }));
        }}
        setEndDate={(e) => {
          setReqBody((prevValue) => ({
            ...prevValue,
            due_date_end: e ? e : "",
          }));
        }}
        resetFunc={() => {
          setReqBody((prevValue) => ({
            ...prevValue,
            offset: 1,
            due_date_start: "",
            due_date_end: "",
          }));
        }}
      />
    </div>
  );
};

export default DefectaList;
